<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir Contas a Pagar</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- CONTENT BODY -->
  <div class="content-body modal-print-container">
    <!-- LOADING STATE -->
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="300px"></app-loading-box>
    </div>
    }

    <!-- TABLE CONTENT -->
    @if (relatorioContas.length > 0) {
    <div [hidden]="isLoading">
      <div class="table-responsive">
        <table mat-table [dataSource]="relatorioContas">
          <!-- Fornecedor Column -->
          <ng-container matColumnDef="fornecedor">
            <th mat-header-cell *matHeaderCellDef style="width: 18%">Fornecedor</th>
            <td mat-cell *matCellDef="let element">{{ element.fornecedor }}</td>
          </ng-container>
          <!-- Histórico Column -->
          <ng-container matColumnDef="historico">
            <th mat-header-cell *matHeaderCellDef style="width: 16%">Histórico</th>
            <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
          </ng-container>
          <!-- Nº Documento Column -->
          <ng-container matColumnDef="numeroDocumento">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">Nº Doc</th>
            <td mat-cell *matCellDef="let element">{{ element.numeroDocumento }}</td>
          </ng-container>
          <!-- Valor Column -->
          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef style="width: 12%">Valor</th>
            <td mat-cell *matCellDef="let element">{{ element.valor | abnt: 'preco': 2 }}</td>
          </ng-container>
          <!-- Pago Column -->
          <ng-container matColumnDef="pago">
            <th mat-header-cell *matHeaderCellDef style="width: 12%">Pago</th>
            <td mat-cell *matCellDef="let element">{{ element.pago | abnt: 'preco': 2 }}</td>
          </ng-container>
          <!-- A Pagar Column -->
          <ng-container matColumnDef="aPagar">
            <th mat-header-cell *matHeaderCellDef style="width: 12%">A Pagar</th>
            <td mat-cell *matCellDef="let element">{{ element.aPagar | abnt: 'preco': 2 }}</td>
          </ng-container>
          <!-- Vencimento Column -->
          <ng-container matColumnDef="vencimento">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">Vencimento</th>
            <td mat-cell *matCellDef="let element">{{ element.vencimento | date: 'dd/MM/yyyy' }}</td>
          </ng-container>
          <!-- Situação Column -->
          <ng-container matColumnDef="situacao">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">Situação</th>
            <td mat-cell *matCellDef="let element">{{ element.situacao }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <!-- Resumo financeiro para impressão -->
      <div class="print-footer-resumo">
        <div class="item">
          <div class="label">Vencidos</div>
          <div class="value text-danger">{{ totalVencidos | abnt: 'preco': 2 }}</div>
        </div>
        <div class="item">
          <div class="label">Vencem Hoje</div>
          <div class="value">{{ totalVencemHoje | abnt: 'preco': 2 }}</div>
        </div>
        <div class="item">
          <div class="label">A Vencer</div>
          <div class="value">{{ totalAVencer | abnt: 'preco': 2 }}</div>
        </div>
        <div class="item">
          <div class="label">Pagos</div>
          <div class="value text-success">{{ totalPagos | abnt: 'preco': 2 }}</div>
        </div>
        <div class="item">
          <div class="label">Total do Período</div>
          <div class="value">{{ totalPeriodo | abnt: 'preco': 2 }}</div>
        </div>
        <div class="item">
          <div class="label">Lançamentos</div>
          <div class="value">{{ quantidadeLancamentos }}</div>
        </div>
      </div>
    </div>
    }

    <!-- EMPTY STATE -->
    @if (!isLoading && relatorioContas.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <!-- FOOTER ACTIONS -->
  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && relatorioContas.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>